import {AfterViewInit, ChangeDetectionStrategy, Component, DoCheck, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {ExcListComponent, ExcListConfig, ExcSectionGroupComponent, OverlayConfig, OverlayRef} from 'exc-controls';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcSigninService} from 'exc-signin';

@Component({
  selector: 'app-modal-dealer-black-white-list',
  templateUrl: './modal-dealer-black-white-list.component.html',
  styles: []
})
export class ModalDealerBlackWhiteListComponent extends ExcTranslation implements OnInit, AfterViewInit, DoCheck {

  @ViewChild('VCSectionGroup', {read: ExcSectionGroupComponent}) VCSectionGroup!: ExcSectionGroupComponent;
  @ViewChild('VCWhiteList', {read: ExcListComponent}) VCWhiteList!: ExcListComponent;
  @ViewChild('VCBlackList', {read: ExcListComponent}) VCBlackList!: ExcListComponent;
  @ViewChild('VCMergeList', {read: ExcListComponent}) VCMergeList!: ExcListComponent;

  WhiteListConfig: ExcListConfig = new ExcListConfig();
  BlackListConfig: ExcListConfig = new ExcListConfig();
  MergeListConfig: ExcListConfig = new ExcListConfig();

  data = {
    Blacklist: [] as any[],
    WhiteList: [] as any[],
  };
  dataClone = {
    Blacklist: [] as any[],
    WhiteList: [] as any[],
  };
  dataInsertMerge = [] as any[];
  dataDealer = [] as any[];

  selectedBlackList = [] as any[];
  blackListSearchValue = '';
  selectedWhiteList = [] as any[];
  whiteListSearchValue = '';
  selectedMergeList = [] as any[];
  mergeListSearchValue = '';

  datepickerConfig: any = {
    maxDate: (new Date()).setFullYear((new Date()).getFullYear() + 5),
    altInput: true,
    allowInput: true,
    dateFormat: this.getGlobal('FormatDate'),
    static: true,
    mode: 'single' // "single", "multiple", or "range" (currently only single is implemented completely
  };

  validate = false;
  dataChanged = false;
  addToWhiteList = false;
  addToBlackList = false;

  countInvalidDates = 0;

  constructor(public overlayRef: OverlayRef,
              private overlayConfig: OverlayConfig,
              private excSignInService: ExcSigninService,
              private excDss: DefaultSettingsService,
  ) {
    super();
  }

  ngOnInit() {
    this.initDatePicker();
    this.initLists();
    this.initData();
    this.initAddData();
  }

  ngAfterViewInit(): void {
    if (this.VCSectionGroup) {
      if (this.dataInsertMerge.length > 0) {
        this.VCSectionGroup.setCurrentTab(2);
      } else {
        this.VCSectionGroup.setCurrentTab(this.overlayConfig.data.selectedTab);
      }
    }
  }

  ngDoCheck(): void {
    this.countInvalidDates = this.dataClone.Blacklist.filter((blackListElement: any) => !blackListElement.InventoryBlackListTo).length;
    this.dataChanged = JSON.stringify(this.data) !== JSON.stringify(this.dataClone);
    this.validate = this.dataChanged
      && this.countInvalidDates === 0
      && this.dataInsertMerge.length === 0;
  }

  initDatePicker(): void {
    // this.datepickerConfig.minDate = (new Date()).setHours(0, 0, 0, 0);
    this.datepickerConfig.maxDate = (new Date()).setFullYear((new Date()).getFullYear() + 5);
  }

  initData(): void {
    this.dataDealer = this.overlayConfig.data.dealer;

    for (const dealer of this.overlayConfig.data.dealer) {
      if (dealer.dlrIWBWhiteList) {
        const whiteListDealer = JSON.parse(dealer.dlrIWBWhiteList);
        for (const whiteListDealerElement of whiteListDealer) {
          Object.assign(whiteListDealerElement, {DealerID: dealer.DealerID});
          this.data.WhiteList.push(whiteListDealerElement);
        }
      }
      if (dealer.dlrIWBBlackList) {
        const blackListDealer = JSON.parse(dealer.dlrIWBBlackList);
        for (const blackListDealerElement of blackListDealer) {
          if (blackListDealerElement.InventoryBlackListTo >= Date.now()) {
            Object.assign(blackListDealerElement, {DealerID: dealer.DealerID});
            this.data.Blacklist.push(blackListDealerElement);
          }
        }
      }
    }
  }

  initAddData() {
    for (const addElement of this.overlayConfig.data.addToWhiteList) {
      if (!this.data.WhiteList.find((listElement: any) => listElement.InventoryVIN === addElement.InventoryVIN)) {
        if (this.data.Blacklist.find((listElement: any) => listElement.InventoryVIN === addElement.InventoryVIN)) {
          this.dataInsertMerge.push(addElement);
          this.selectedMergeList.push(addElement);
        } else if (addElement) {
          this.dataClone.WhiteList.push(addElement);
          this.selectedWhiteList.push(addElement);
        }
      }
    }

    for (const addElement of this.overlayConfig.data.addToBlackList) {
      if (!this.data.Blacklist.find((listElement: any) => listElement.InventoryVIN === addElement.InventoryVIN)) {
        Object.assign(addElement, {InventoryBlackListTo: null});
        if (this.data.WhiteList.find((listElement: any) => listElement.InventoryVIN === addElement.InventoryVIN)) {
          this.dataInsertMerge.push(addElement);
          this.selectedMergeList.push(addElement);
        } else if (addElement) {
          this.dataClone.Blacklist.push(addElement);
          this.selectedBlackList.push(addElement);
        }
      }
    }


    this.VCWhiteList.selectedItems = this.selectedWhiteList;
    this.VCBlackList.selectedItems = this.selectedBlackList;

    for (const whiteListElement of this.data.WhiteList) {
      this.dataClone.WhiteList.push(whiteListElement);
    }
    for (const blackListElement of this.data.Blacklist) {
      this.dataClone.Blacklist.push(blackListElement);
    }


    this.addToWhiteList = this.overlayConfig.data.addToWhiteList.length > 0;
    this.addToBlackList = this.overlayConfig.data.addToBlackList.length > 0;
  }

  initLists(): void {
    this.WhiteListConfig.selectionMode = 'multi';
    this.WhiteListConfig.paging = {pagingTotalRows: this.dataClone.WhiteList.length, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    this.WhiteListConfig.OnSearch = (searchValue, event?) => {
      this.whiteListSearchValue = searchValue || '';
      this.VCWhiteList._config.paging.pagingTotalRows = this.getWhiteListData().length;
    };
    this.WhiteListConfig.OnPageChanged = (pageNo, event1) => {
      this.WhiteListConfig.paging.pagingPage = pageNo;
    };
    this.WhiteListConfig.OnRefresh = () => {
    };
    this.WhiteListConfig.OnSelectionChanged = (selecteditems, event) => {
      this.selectedWhiteList = selecteditems;
    };

    this.BlackListConfig.selectionMode = 'multi';
    this.BlackListConfig.paging = {pagingTotalRows: this.dataClone.Blacklist.length, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    this.BlackListConfig.OnSearch = (searchValue, event?) => {
      this.blackListSearchValue = searchValue || '';
      this.VCBlackList._config.paging.pagingTotalRows = this.getBlackListData().length;
    };
    this.BlackListConfig.OnPageChanged = (pageNo, event1) => {
      this.BlackListConfig.paging.pagingPage = pageNo;
    };
    this.BlackListConfig.OnRefresh = () => {
    };
    this.BlackListConfig.OnSelectionChanged = (selecteditems, event) => {
      this.selectedBlackList = selecteditems;
    };

    this.MergeListConfig.selectionMode = 'multi';
    this.MergeListConfig.paging = {pagingTotalRows: this.dataInsertMerge.length, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    this.MergeListConfig.OnSearch = (searchValue, event?) => {
      this.mergeListSearchValue = searchValue || '';
      this.VCMergeList._config.paging.pagingTotalRows = this.getMergeListData().length;
    };
    this.MergeListConfig.OnPageChanged = (pageNo, event1) => {
      this.MergeListConfig.paging.pagingPage = pageNo;
    };
    this.MergeListConfig.OnRefresh = () => {
    };
    this.MergeListConfig.OnSelectionChanged = (selecteditems, event) => {
      this.selectedMergeList = selecteditems;
    };
  }

  getDealer(dealerID: any): any {
    return this.dataDealer.find((dealer: any) => dealer.DealerID === dealerID);
  }

  getWhiteListData(): any[] {
    if (this.dataClone.WhiteList
      && this.dataClone.WhiteList.length > 0
      && this.whiteListSearchValue
      && this.whiteListSearchValue.length > 0
    ) {
      return this.dataClone.WhiteList.filter((listElement: any) => JSON.stringify(listElement).toUpperCase().includes(this.whiteListSearchValue.toUpperCase()));
    }
    return this.dataClone.WhiteList;
  }

  getBlackListData(): any[] {
    if (this.dataClone.Blacklist
      && this.dataClone.Blacklist.length > 0
      && this.blackListSearchValue
      && this.blackListSearchValue.length > 0
    ) {
      return this.dataClone.Blacklist.filter((listElement: any) => JSON.stringify(listElement).toUpperCase().includes(this.blackListSearchValue.toUpperCase()));
    }
    return this.dataClone.Blacklist;
  }

  getMergeListData(): any[] {
    if (this.dataInsertMerge
      && this.dataInsertMerge.length > 0
      && this.mergeListSearchValue
      && this.mergeListSearchValue.length > 0
    ) {
      return this.dataInsertMerge.filter((listElement: any) => JSON.stringify(listElement).toUpperCase().includes(this.mergeListSearchValue.toUpperCase()));
    }
    return this.dataInsertMerge;
  }

  moveToWhiteList(moveSelection: any[], skipTabSwitch = false) {
    this.deleteBlackList();
    for (const moveSelectionElement of moveSelection) {
      delete moveSelectionElement.InventoryBlackListTo;
      this.dataClone.WhiteList.unshift(moveSelectionElement);
      if (!this.selectedWhiteList.find((selected: any) => selected.InventoryVIN === moveSelectionElement.InventoryVIN)) {
        this.selectedWhiteList.push(moveSelectionElement);
      }
    }
    this.dataClone.WhiteList = JSON.parse(JSON.stringify(this.dataClone.WhiteList));
    this.VCWhiteList.selectedItems = this.selectedWhiteList;

    if (!skipTabSwitch) {
      this.VCSectionGroup.setCurrentTab(0);
    }
  }

  moveToBlackList(moveSelection: any[], skipTabSwitch = false) {
    this.deleteWhiteList();
    for (const moveSelectionElement of moveSelection) {
      Object.assign(moveSelectionElement, {InventoryBlackListTo: null});
      this.dataClone.Blacklist.unshift(moveSelectionElement);
      if (!this.selectedBlackList.find((selected: any) => selected.InventoryVIN === moveSelectionElement.InventoryVIN)) {
        this.selectedBlackList.push(moveSelectionElement);
      }
    }
    this.dataClone.Blacklist = JSON.parse(JSON.stringify(this.dataClone.Blacklist));
    this.VCBlackList.selectedItems = this.selectedBlackList;

    if (!skipTabSwitch) {
      this.VCSectionGroup.setCurrentTab(1);
    }
  }

  moveMergeList(mergeElement: any[]) {
    this.deleteMergeList();
    if (this.addToWhiteList) {
      this.dataClone.Blacklist = this.deleteFromList(this.dataClone.Blacklist, mergeElement);
      this.moveToWhiteList([mergeElement], true);
    } else if (this.addToBlackList) {
      this.dataClone.WhiteList = this.deleteFromList(this.dataClone.WhiteList, mergeElement);
      this.moveToBlackList(mergeElement, true);
    }
  }

  moveMergeListElement(mergeElement: any) {
    if (this.addToWhiteList) {
      this.dataClone.Blacklist = this.deleteFromList(this.dataClone.Blacklist, [mergeElement]);
      this.moveToWhiteList([mergeElement], true);
    } else if (this.addToBlackList) {
      this.dataClone.WhiteList = this.deleteFromList(this.dataClone.WhiteList, [mergeElement]);
      this.moveToBlackList([mergeElement], true);
    }
    this.dataInsertMerge = this.deleteFromList(this.dataInsertMerge, [mergeElement]);
  }

  deleteWhiteList() {
    this.dataClone.WhiteList = this.deleteFromList(this.dataClone.WhiteList, this.selectedWhiteList);
    this.VCWhiteList.clearSelection({});
  }

  deleteBlackList() {
    this.dataClone.Blacklist = this.deleteFromList(this.dataClone.Blacklist, this.selectedBlackList);
    this.VCBlackList.clearSelection({});
  }

  deleteMergeListElement(mergeElement: any) {
    this.dataInsertMerge = this.deleteFromList(this.dataInsertMerge, [mergeElement]);
  }

  deleteMergeList() {
    this.dataInsertMerge = this.deleteFromList(this.dataInsertMerge, this.selectedMergeList);
    this.VCMergeList.clearSelection({});
  }

  deleteFromList(deleteFromList: any[], deleteSelection: any[]): any[] {
    for (const deleteElement of deleteSelection) {
      deleteFromList = deleteFromList.filter((listElement: any) => listElement.InventoryVIN !== deleteElement.InventoryVIN);
    }
    return deleteFromList;
  }

  changeLCD(dataBlacklistItem: any) {
    const indexItem = this.dataClone.Blacklist.indexOf(dataBlacklistItem);

    this.dataClone.Blacklist[indexItem].InventoryWhiteBlackLCD = new Date().getTime();
    this.dataClone.Blacklist[indexItem].InventoryWhiteBlackLCU = this.excSignInService.UserName;
  }

  proceed(): void {
    if (!this.validate) {
      return;
    }

    const dealerListResult = this.dataDealer.map(dealer => ({
        DealerID: dealer.DealerID
      }));
    const whiteListResult = this.dataClone.WhiteList.map(x => ({
      DealerID: x.DealerID,
      InventoryVIN: x.InventoryVIN,
      InventoryCreditType: x.InventoryCreditType,
      InventoryDescription: x.InventoryDescription,
      InventoryWhiteBlackReason: x.InventoryWhiteBlackReason,
      InventoryWhiteBlackCRU: x.InventoryWhiteBlackCRU,
      InventoryWhiteBlackCRD: typeof x.InventoryWhiteBlackCRD === 'number' ? x.InventoryWhiteBlackCRD : new Date(x.InventoryWhiteBlackCRD).getTime(),
      InventoryWhiteBlackLCU: x.InventoryWhiteBlackLCU,
      InventoryWhiteBlackLCD: typeof x.InventoryWhiteBlackLCD === 'number' ? x.InventoryWhiteBlackLCD : new Date(x.InventoryWhiteBlackLCD).getTime(),
      InventoryPlannedAuditID: x.InventoryPlannedAuditID
    }));
    const blackListResult = this.dataClone.Blacklist.map(x => ({
      DealerID: x.DealerID,
      InventoryVIN: x.InventoryVIN,
      InventoryCreditType: x.InventoryCreditType,
      InventoryDescription: x.InventoryDescription,
      InventoryWhiteBlackReason: x.InventoryWhiteBlackReason,
      InventoryWhiteBlackCRU: x.InventoryWhiteBlackCRU,
      InventoryWhiteBlackCRD: typeof x.InventoryWhiteBlackCRD === 'number' ? x.InventoryWhiteBlackCRD : new Date(x.InventoryWhiteBlackCRD).getTime(),
      InventoryWhiteBlackLCU: x.InventoryWhiteBlackLCU,
      InventoryWhiteBlackLCD: typeof x.InventoryWhiteBlackLCD === 'number' ? x.InventoryWhiteBlackLCD : new Date(x.InventoryWhiteBlackLCD).getTime(),
      InventoryBlackListTo: typeof x.InventoryBlackListTo === 'number' ? x.InventoryBlackListTo : new Date(x.InventoryBlackListTo).getTime(),
    }));

    this.overlayRef.close({
      proceed: true,
      dealerListJSON: JSON.stringify(dealerListResult),
      whiteListJSON: JSON.stringify(whiteListResult),
      blackListJSON: JSON.stringify(blackListResult)
    });
  }
}
